<template>
	<div>
        <div class="title">
            <div class="left" v-if="currentRound.hasPrev"  @click="changeRound('prev')"><img src="@/assets/images/icon_left.png" alt=""> 上一轮</div>
            {{ currentRound.name_chs }}
            <div class="right" v-if="currentRound.hasNext" @click="changeRound('next')">下一轮<img src="@/assets/images/icon_right.png" alt=""></div>
        </div>
        <table v-if="detail.length">
            <tbody>
                <tr  v-for="item,i in detail" :key="i" @click="goLive(item)">
                    <td width="200px">{{item.match_time_int | formatDate}}</td>
                    <td class="home-name">
                        {{item.home_name_zh}}
                        <img :src="item.home_logo" alt="">
                    </td>
                    <td class="score" width="100px" v-if="item.state >= 0">VS</td>
                    <td class="score" width="100px" v-else>{{item.home_score}}-{{item.away_score}}</td>
                    
                    <td class="away-name">
                        <img :src="item.away_logo" alt="">
                        {{item.away_name_zh}}
                    </td>
                    <td width="200px"></td>
                </tr>
            </tbody>
        </table>
        <div v-else class="nodata">暂无数据</div>
	</div>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
export default {
	data() {
		return {
		}
        
	},
    filters: {
        formatDate(value) {
            return dayjs.unix(value).format('YYYY-MM-DD HH:mm');
        }
    },
    props: ['detail','currentRound'],
	created() {
	},
	beforeMount() {

	},
	computed:{

		
	},	
	methods: {
        changeRound(type){
            this.$emit('changeRound', type);
        },
        goLive(item){
            // if(item.state >= 0){
                window.open(window.location.protocol +"//" +window.location.host +`/zuqiu/live?id=${item.tournament_id}&zhibo=${item.is_tv}`);
            // }
           
        }
	},
}
</script>

<style lang="less">
    .title{
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        background: #e24949;
        font-size: 18px;
        position: relative;
        >div{
            position: absolute;
            top: 0;
            display: flex;
            align-items: center;
            cursor: pointer;
            img{
                margin: 0 10px;
            }
        }
        .left{
            left: 0;
        }
        .right{
            right: 0;
        }
    }
    thead tr {
        border: none;    
    }
    table{
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        margin-bottom:20px;
        thead{
            width: 100%;
            tr{
                background: #f7f7f7;
                color: #333;
                height: 48px;
                line-height: 48px;
                border-bottom: 1px solid #ededed;
                text-align: center;
            }
        }
        tbody{
            width: 100%;
            tr{
                background: #f7f7f7;
                color: #333;
                height: 60px;
                line-height: 60px;
                border-bottom: 1px solid #e7f7eb;
                text-align: center;
                cursor: pointer;
            }
        }
        .home-name{
            text-align: right;
            padding-left: 20px;
            img{
                width: 30px;
                height: 30px;
                margin:0 10px 0 0;
                position: relative;
                bottom: -10px;
            }
        }
        .away-name{
            text-align: left;
            padding-left: 20px;
            img{
                width: 30px;
                height: 30px;
                margin:0 10px 0 0;
                position: relative;
                bottom: -10px;
            }
        }

    }
    .nodata{
        width: 940px;
        text-align: center;
        height: 400px;
        line-height: 400px;
        color: #999;
    }
</style>
